import { render } from "./ErrorHistoryTable.vue?vue&type=template&id=696042b0"
import script from "./ErrorHistoryTable.vue?vue&type=script&lang=js"
export * from "./ErrorHistoryTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__